module.exports = __webpack_public_path__ + "assets/img/mtTitle-a490f050.png";